// App.js:
import React, { useState } from 'react';
import SplitPane, { Pane } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
import ImageViewer from './Components/ImageViewer';
import ImageUpload from './Components/ImageUpload';
import AnnotationForm from './Components/AnnotationForm';  
import './App.css';
import Box from '@mui/material/Box';
//store imports
import { Provider } from 'react-redux';
import { store } from './redux/store';




function App() {
    const [selectedImage, setSelectedImage] = useState(null);
    const [sizes, setSizes] = useState(['67%', '33%']); 

    return (
        <Provider store={store}>
        <SplitPane split='vertical' sizes={sizes} onChange={setSizes}>
            <Pane minSize='30%' maxSize='70%'>
                <div className="left-container">
                    <ImageViewer selectedImage={selectedImage} />
                </div>
            </Pane>
            <Box className="right-container" sx={{ px: 2 }}>
                <div className="upper-portion">
                    <ImageUpload setSelectedImage={setSelectedImage} />
                </div>
                <div className="lower-portion">
                    <AnnotationForm />  {}
                </div>
            </Box>
        </SplitPane>
        </Provider>
    );
}

export default App;
